<div
  [froalaEditor]="computedOptions"
  [(froalaModel)]="value"
  (froalaModelChange)="onContentChanged($event)"
></div>
